import logo from "./logo.svg";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Game from "./pages/Game";
import Profile from "./pages/Profile";
import Address from "./pages/Address";
import AddAddress from "./pages/AddAddress";
import CartPage from "./pages/Cart";
import ProfileOrders from "./pages/ProfileOrders";
import Order from "./pages/Restaurant";
import Restaurant from "./pages/Restaurant";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import "./i18n";
import { CartProvider } from "./context/CartContext";
import FriendsPage from "./pages/Friends";
import NotificationPage from "./pages/NotificationPage";

function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/game" element={<Game />} />
          <Route path="/notification" element={<NotificationPage />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/orders" element={<ProfileOrders />} />
          <Route path="/profile/address" element={<Address />} />
          <Route path="/profile/friends" element={<FriendsPage />} />
          <Route path="/profile/add-address" element={<AddAddress />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App;
